import { useQuery, } from 'react-query';

import { type IUser } from 'src/api/users-api';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api';

type GetTeamMembersResponse = {
    members: IUser[];
};

type IGetTeamMembersOptions = {
    includeInactive?: boolean;
    refetchInterval?: number | false;
};

/**
 * Fetches team members. By default, returns only active members.
 * Pass includeInactive: true to include deactivated members (only for Team Members management page).
 */
export const useTeamMembers = (options?: IGetTeamMembersOptions) => {
    const includeInactive = options?.includeInactive ?? false;
    const refetchInterval = options?.refetchInterval ?? false;
    return useQuery(
        [queryKeys.teamMembers, includeInactive],
        async () => {
            const res = await apiClient('api/landlord/team/members').json<GetTeamMembersResponse>();
            return includeInactive ? res.members : res.members.filter(member => member.is_active);
        },
        { refetchInterval },
    );
};

export default useTeamMembers;